<div class="duty-board" [class.duty-board--stacked]="isStacked()">
  @if (isLoading()) {
    <div class="duty-board__skeleton" aria-busy="true" aria-live="polite">
      @if (!isMobile()) {
        <span class="duty-board__skeleton-hint">
          {{ 'app.components.assignmentBoard.loading' | translate }}
        </span>
      }
      <div
        class="duty-board__columns"
        [class.duty-board__columns--stacked]="isStacked()"
      >
        @for (col of skeletonColumns; track col) {
          <div class="duty-column duty-column--skeleton">
            <div class="duty-column__skeleton-header"></div>
            <div class="duty-column__skeleton-body">
              @for (card of skeletonCards; track card) {
                <div class="duty-column__skeleton-card"></div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  } @else if (showSelectChildEmpty()) {
    <app-home-empty-state [selectChildScope]="true" />
  } @else if (allDutiesCount() === 0) {
    <app-home-empty-state />
  } @else {
    <header class="duty-board__header">
      <p class="duty-board__subtitle">
        {{ 'app.components.assignmentBoard.subtitle' | translate }}
      </p>
      <div class="duty-board__actions">
        <button
          type="button"
          class="duty-board__secondary-btn"
          [class.duty-board__secondary-btn--locked]="!routinesAllowed()"
          [attr.aria-label]="'app.components.assignmentBoard.routinesAria' | translate"
          (click)="onUseTemplate($event)"
        >
          {{ 'app.components.assignmentBoard.routines' | translate }}
        </button>
        <button
          type="button"
          class="duty-board__add-btn"
          [attr.aria-label]="'app.components.assignmentBoard.addDutyAria' | translate"
          (click)="onAddNewAssignment($event)"
        >
          <span class="duty-board__add-icon" aria-hidden="true"></span>
          {{ 'app.components.assignmentBoard.addDuty' | translate }}
        </button>
      </div>
    </header>

    <div
      class="duty-board__columns"
      [class.duty-board__columns--stacked]="isStacked()"
      role="list"
      [attr.aria-label]="'app.components.assignmentBoard.columnsLabel' | translate"
    >
      @for (column of columns(); track column.id) {
        <section
          class="duty-column"
          [class.duty-column--collapsed]="isColumnCollapsed(column.id)"
          [class.duty-column--expanded]="isColumnExpanded(column.id)"
          role="listitem"
        >
          @if (isStacked()) {
            <button
              type="button"
              class="duty-column__header duty-column__header--toggle"
              [class.duty-column__header--new]="column.id === 'new'"
              [class.duty-column__header--marked]="column.id === 'marked'"
              [class.duty-column__header--done]="column.id === 'done'"
              [attr.aria-expanded]="isColumnExpanded(column.id)"
              (click)="toggleColumn(column.id)"
            >
              <span class="duty-column__badge">{{ column.count }}</span>
              <span class="duty-column__title">{{ column.titleKey | translate }}</span>
              <span
                class="duty-column__chevron"
                [class.duty-column__chevron--open]="isColumnExpanded(column.id)"
                aria-hidden="true"
              ></span>
            </button>
          } @else {
            <div
              class="duty-column__header"
              [class.duty-column__header--new]="column.id === 'new'"
              [class.duty-column__header--marked]="column.id === 'marked'"
              [class.duty-column__header--done]="column.id === 'done'"
            >
              <span class="duty-column__badge">{{ column.count }}</span>
              <span class="duty-column__title">{{ column.titleKey | translate }}</span>
            </div>
          }

          @if (!isColumnCollapsed(column.id)) {
            <div class="duty-column__body">
              @if (column.duties.length === 0) {
                <p class="duty-column__empty">
                  {{ 'app.components.assignmentBoard.columnEmpty' | translate }}
                </p>
              } @else {
                @for (assignment of column.duties; track assignment.id) {
                  <app-assignment-card
                    [id]="assignment.id"
                    [title]="assignment.title"
                    [description]="assignment.content"
                    [status]="column.cardStatus"
                    [rewardGold]="assignment.rewardGold"
                    [rewardXp]="assignment.rewardXp"
                    [read]="assignment.read"
                    [isOverdue]="assignment.isOverdue"
                    [creationDate]="assignment.creationDate"
                    [completionDate]="assignment.completionDate"
                    [confirmationDate]="assignment.confirmationDate"
                    [completionNotes]="assignment.completionNotes"
                    [recurrenceFrequency]="assignment.recurrenceFrequency"
                    [requiresParentParticipation]="assignment.requiresParentParticipation"
                    [parentNote]="assignment.parentNote"
                    [parentCompleted]="assignment.parentCompleted"
                    [routineProgress]="routineProgressByDutyId().get(assignment.id) ?? null"
                    [isSelected]="isCardSelected(assignment.id)"
                    (cardSelected)="onCardSelected(assignment.id)"
                    (editRequested)="onEditAssignment(assignment)"
                  />
                }
              }
            </div>
          }
        </section>
      }
    </div>
  }
</div>
